export const reverseMapSearch = (enumObj, value) =>
  Object.keys(enumObj)[(Object.values(enumObj) as string[]).indexOf(value)];
